export const TAX_MODULES = {
  AU: {
    country: "Australia",
    verified: false,
    source: "https://www.ato.gov.au/tax-rates-and-codes/tax-rates-australian-residents",
    note: "ATO rate, residency, Medicare levy and offset rules must be verified for the selected income year before calculation is enabled.",
  },
  BD: {
    country: "Bangladesh",
    verified: false,
    source: "https://nbr.gov.bd/regulations/acts/income-tax/eng",
    note: "NBR Finance Act schedules, taxpayer category, minimum tax, rebate and residency rules must be verified for the selected assessment year before calculation is enabled.",
  },
};

export function taxModule(country) {
  return TAX_MODULES[country] || null;
}

export function incompleteTaxResult(country, actual = {}) {
  const module = taxModule(country);
  return {
    complete: false,
    country: module?.country || null,
    actual,
    projectedIncome: null,
    estimatedLiability: null,
    withheld: actual.tax_withheld ?? null,
    balancePayableOrRefund: null,
    reason: module?.note || "Choose a supported tax country. Display currency does not choose tax jurisdiction.",
    source: module?.source || null,
  };
}
